import {
  onChange,
  onCheck,
  onClick,
  onFileRemoved,
  onFileUploaded,
  onSubmit
} from '@/plugins/amplitude';
import { debounce } from 'lodash';

export const amplitudeMixin = {
  props: {
    amplitudeAttribute: {
      type: Object,
      default: () => ({})
    },

    amplitudeDebounceDelay: {
      type: Object,
      default: () => ({
        onClick: null,
        onSubmit: null,
        onChange: null,
        onFileUploaded: null,
        onFileRemoved: null,
        onCheck: null
      })
    },

    amplitudeDisableTrack: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    $_amplitudeMixin_calledIfEnableTrack(fn, ...props) {
      if (!this.amplitudeDisableTrack) {
        fn(...props);
      }
    },

    $_amplitudeMixin_onClick(target, props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onClick, this.$amplitudeClient, target, props);
    },

    $_amplitudeMixin_onSubmit(target, props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onSubmit, this.$amplitudeClient, target, props);
    },

    $_amplitudeMixin_onChange(target, props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onChange, this.$amplitudeClient, target, props);
    },

    $_amplitudeMixin_onCheck(props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onCheck, this.$amplitudeClient, props);
    },

    $_amplitudeMixin_onFileUploaded(file, props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onFileUploaded, this.$amplitudeClient, file, props);
    },

    $_amplitudeMixin_onFileRemoved(file, props) {
      this.$_amplitudeMixin_calledIfEnableTrack(onFileRemoved, this.$amplitudeClient, file, props);
    }
  },

  mounted() {
    if (this.amplitudeDebounceDelay.onClick) {
      this.$_amplitudeMixin_onClick = debounce(
        this.$_amplitudeMixin_onClick,
        this.amplitudeDebounceDelay.onClick
      );
    }
    if (this.amplitudeDebounceDelay.onSubmit) {
      this.$_amplitudeMixin_onSubmit = debounce(
        this.$_amplitudeMixin_onSubmit,
        this.amplitudeDebounceDelay.onSubmit
      );
    }
    if (this.amplitudeDebounceDelay.onChange) {
      this.$_amplitudeMixin_onChange = debounce(
        this.$_amplitudeMixin_onChange,
        this.amplitudeDebounceDelay.onChange
      );
    }
    if (this.amplitudeDebounceDelay.onFileUploaded) {
      this.$_amplitudeMixin_onFileUploaded = debounce(
        this.$_amplitudeMixin_onFileUploaded,
        this.amplitudeDebounceDelay.onFileUploaded
      );
    }
    if (this.amplitudeDebounceDelay.onFileRemoved) {
      this.$_amplitudeMixin_onFileRemoved = debounce(
        this.$_amplitudeMixin_onFileRemoved,
        this.amplitudeDebounceDelay.onFileRemoved
      );
    }
    if (this.amplitudeDebounceDelay.onCheck) {
      this.$_amplitudeMixin_onCheck = debounce(
        this.$_amplitudeMixin_onCheck,
        this.amplitudeDebounceDelay.onCheck
      );
    }
  }
};
